import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["entities", "parent"];
import React from 'react';
import PropTypes from 'prop-types';
import MenuItemRender from './MenuItemRender';
import MenuEntitiesItem from './MenuEntitiesItem';
const MenuItem = _ref => {
  let {
      entities,
      parent
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const hasEntities = entities && entities.length;
  if (!hasEntities) return /*#__PURE__*/React.createElement(MenuItemRender, _extends({
    parent: parent
  }, props));
  return /*#__PURE__*/React.createElement(MenuEntitiesItem, _extends({
    entities: entities,
    parent: parent
  }, props));
};
MenuItem.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  eventType: PropTypes.string.isRequired,
  modifier: PropTypes.string,
  parent: PropTypes.object,
  text: PropTypes.string,
  url: PropTypes.string,
  entities: PropTypes.array
};
MenuItem.defaultProps = {
  children: null,
  modifier: '',
  parent: {},
  text: '',
  url: '',
  entities: []
};
export default MenuItem;
//# sourceMappingURL=MenuItem.js.map